import "core-js/modules/esnext.async-iterator.filter.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.async-iterator.for-each.js";
import "core-js/modules/esnext.iterator.for-each.js";
import _defineProperty from "/app/node_modules/.pnpm/next@15.3.3_@babel+core@7.27.4_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react_7cca35337dd8404c2bdaa7eb9a6410df/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { createContext, useContext } from "react";
import { useCurrentPageType } from "shared/hooks/current-page-type";

// TODO: use base link context for replacing all customQueryParameters in props

const BaseLinkContext = /*#__PURE__*/createContext({
  customQueryParameters: undefined
});
export const BaseLinkContextProvider = _ref => {
  let {
    children,
    customQueryParameters
  } = _ref;
  const pageType = useCurrentPageType();
  return __jsx(BaseLinkContext.Provider, {
    value: {
      customQueryParameters: _objectSpread({
        pgtype: pageType
      }, customQueryParameters)
    }
  }, children);
};
export const useBaseLinkContext = () => useContext(BaseLinkContext);